import { LinkContainer } from "react-router-bootstrap";
import { Invite } from "../../libs/shared/model";

export default function JobLinkContainer({item, ...props}){
    return(
        <LinkContainer to={item.status === Invite.inviteStatusTypes.APP_SUBMITTED ? `/invites/${item.inviteId}` : `/invites/${item.inviteId}`}>
            {props.children}
        </LinkContainer>
    )
}